export class OAuthError extends Error {
  constructor(error, errorDescription) {
    super(errorDescription || error);
  }
}
